import {
    Avatar,
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    IconButton,
    Input,
    InputGroup,
    InputLeftElement,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure, useToast
} from "@chakra-ui/react";
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { AiOutlineUserAdd } from "react-icons/ai";
import { FiSearch } from "react-icons/fi";
import { RelationShip, Student } from "../../interfaes/student";
import MaterialTable, { Column } from "material-table";
import { createTheme, ThemeProvider } from '@mui/material';
import { GrEdit } from "react-icons/gr";
import { MdDelete } from "react-icons/md";
import { CgArrowsExchange } from "react-icons/cg";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { onChangeRole, onDeleteStudent, onGetMyStudents, onGetStudents } from "../../http/student";
import { Roles, User } from "../../interfaes/user";
import CoustomAlertDialog from "../../components/CoustomAlertDialog";
import SearchableSelect from "../../components/SearchableSelect";
import { School } from "../../interfaes/school";
import { onGetUsers } from "../../http/users";
import { canAddStudent, isAdmin } from "../../utils/common";
import ModernLoader from "../../components/ModernLoader";


export default function StudentsPage() {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const toast = useToast();

    const { t } = useTranslation('studentLocal');
    const [data, setData] = useState([]);
    const [relationShip, setRelationShip] = useState<RelationShip[]>([]);
    const [users, setUsers] = useState<User[]>([]);
    const [deleteIndex, setDeleteIndex] = useState("");
    const [selectedRole, setSelectedRole] = useState(Roles.TEACHER);
    const [relationshipId, setRelationshipId] = useState("");
    const [selectedStudent, setSelectedStudent] = useState<any>(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOpenTransfer, onOpen: onOpenTransfer, onClose: onCloseTransfer } = useDisclosure();
    const { pathname } = location;
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedProvince, setSelectedProvince] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedTeacher, setSelectedTeacher] = useState("");

    const provinces = useMemo(() => Array.from(new Set(data.map((s: Student) => s.province).filter(Boolean))).sort(), [data]);
    const districts = useMemo(() => {
        const from = selectedProvince
            ? data.filter((s: Student) => s.province === selectedProvince).map((s: Student) => s.district)
            : data.map((s: Student) => s.district);
        return Array.from(new Set(from.filter(Boolean))).sort();
    }, [data, selectedProvince]);

    const teachers = useMemo(() => {
        const tNames = data.map((s: Student) => s.relationships?.find(r => r.relation === Roles.TEACHER)?.relatedUser?.displayName).filter(Boolean);
        return Array.from(new Set(tNames)).sort();
    }, [data]);

    const filteredData = useMemo(() => {
        return data.filter((row: Student) => {
            const matchSearch = !searchTerm || [
                row.fullName,
                row.province,
                row.district,
                row.localAddress,
                row.localLevel
            ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase()
                .includes(searchTerm.toLowerCase());
            const matchProvince = !selectedProvince || row.province === selectedProvince;
            const matchDistrict = !selectedDistrict || row.district === selectedDistrict;

            const teacher = row?.relationships?.find((r) => r.relation === Roles.TEACHER)?.relatedUser?.displayName;
            const matchTeacher = !selectedTeacher || teacher === selectedTeacher;

            return matchSearch && matchProvince && matchDistrict && matchTeacher;
        });
    }, [data, searchTerm, selectedProvince, selectedDistrict, selectedTeacher]);


    const calculateAgeFromTimestamp = (timestamp: number): number => {
        // Convert the timestamp to a Date object
        const birthDate = new Date(timestamp);
        // Multiply by 1000 to convert from seconds to milliseconds

        // Get the current date
        const currentDate = new Date();

        // Calculate the age
        const age = currentDate.getFullYear() - birthDate.getFullYear();

        // Check if the birthdate has occurred this year
        // If the birthdate hasn't occurred yet, subtract 1 from the age
        if (
            currentDate.getMonth() < birthDate.getMonth() ||
            (currentDate.getMonth() === birthDate.getMonth() &&
                currentDate.getDate() < birthDate.getDate())
        ) {
            return age - 1;
        }

        return age;
    }


    const columns: Column<Student>[] = [
        { title: t('id'), field: 'id', type: 'numeric', hidden: true },
        {
            title: t('name'), field: 'name',
            render: rowData => (
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={() => handleRowClick(rowData)}>

                    <Avatar name={rowData.fullName} src={rowData.studentImage} mr={'12px'} w={'40px'} h={'40px'} background={'#e2e8f0'} />

                    {rowData.fullName}
                </div>
            ),
            customFilterAndSearch: (term, rowData) => (rowData.fullName).indexOf(term) !== -1
        },
        {
            title: t('manageStudents.age'), field: 'dob',
            render: rowData => (
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleRowClick(rowData)}>
                    {calculateAgeFromTimestamp(rowData.dob)}
                </div>
            )
        },
        {
            title: t('teacherName'), field: 'teacherName',
            render: rowData => (
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleRowClick(rowData)}>
                    {rowData?.relationships?.filter((r) => r.relation === Roles.TEACHER) ? rowData?.relationships?.filter((r) => r.relation === Roles.TEACHER)[0]?.relatedUser.displayName : '-'}
                </div>
            )
        },
        {
            title: t('parentsName'), field: 'parentsName',
            render: rowData => (
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleRowClick(rowData)}>
                    {rowData?.relationships?.filter((r) => r.relation === Roles.TEACHER) ? rowData?.relationships?.filter((r) => r.relation === Roles.PARENT)[0]?.relatedUser.displayName : '-'}
                </div>
            )
        },
        {
            title: t('manageStudents.address'), field: 'address',
            render: rowData => (
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleRowClick(rowData)}>
                    {`${rowData?.localAddress}, ${rowData?.district}, ${rowData?.province}`}
                </div>
            ),
            customFilterAndSearch: (term, rowData) => (`${rowData?.localAddress}, ${rowData?.district}, ${rowData?.province}`).indexOf(term) !== -1

        },
    ];
    const defaultMaterialTheme = createTheme();

    const navigate = useNavigate();


    const getStudents = useCallback(async () => {
        try {
            setLoading(true);
            if (location.pathname === '/my_students') {
                const response = await onGetMyStudents();
                setData(response.data)
            } else {
                const response = await onGetStudents();
                setData(response.data.items)
            }
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false);
        }
    }, [location.pathname]);

    const getUsers = useCallback(async () => {
        try {
            const response = await onGetUsers();
            setUsers(response.data.userResponseList)
        } catch (e) {
            console.log(e);
        }
    }, []);

    useEffect(() => {
        getStudents();
        getUsers();
    }, [getStudents, getUsers])


    const handleClose = () => {
        setDeleteIndex('');
        setLoading(false)
        onClose();

    }

    const resetTransferState = () => {
        setSelectedStudent(null);
        setRelationshipId('');
        setSelectedRole(Roles.TEACHER);
    };

    const onDeleteStudents = async () => {
        try {
            setLoading(true)
            await onDeleteStudent(deleteIndex);
            const arrayOfObjects = data.filter((obj: School) => obj.id !== deleteIndex);
            setData(arrayOfObjects);
            getStudents();
            toast({
                title: 'Deleted',
                description: "Student Deleted Successfully!",
                status: 'success',
                duration: 3000,
                isClosable: true,
            })

        } catch (e) {
            toast({
                title: 'Error',
                // @ts-ignore
                description: e?.response?.data?.message,
                status: 'error',
                duration: 3000,
                isClosable: true,
            })
        } finally {
            handleClose();
        }
    }


    const onTransferStudent = async () => {
        if (!relationshipId) {
            toast({
                title: t('transfer.errorSelectUser'),
                description: t('transfer.errorSelectUser'),
                status: 'warning',
                duration: 4000,
                isClosable: true,
            });
            return;
        }
        try {
            setLoading(true);
            const rObj = relationShip.find((r) => r.relation === selectedRole);
            const rID = rObj ? rObj.relationshipId : "";
            await onChangeRole(deleteIndex, rID, relationshipId, selectedRole);
            await getStudents();
            onCloseTransfer();
            resetTransferState();
            toast({
                title: 'Transferred',
                description: `Student's ${selectedRole === Roles.TEACHER ? 'teacher' : 'therapist'} transferred successfully.`,
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
        } catch (e: any) {
            const serverMsg = e?.response?.data?.message;
            toast({
                title: t('transfer.errorGeneral'),
                description: serverMsg || t('transfer.errorGeneral'),
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };


    const onGetIcon = (id: string) => {
        if (id === 'edit') {
            return <GrEdit size="20px" color={"red"} />;

        } else if (id === 'transfer') {
            return <CgArrowsExchange size="20px" color={"orange"} />;
        } else {

            return <MdDelete size="20px" color={"red"} />
        }


    }


    const handleRowClick = (rowData: any) => {
        if (!rowData.studentId) return;
        navigate("/students-profile/" + rowData.studentId, { state: rowData });
    };


    return <Box>
        <Flex justifyContent="space-between">
            <Text fontSize="30px" fontWeight={900}>
                {t('students')}
            </Text>
            {canAddStudent() && (pathname === '/my_students' || pathname === '/students') && (
                <Button leftIcon={<AiOutlineUserAdd />} background={"#1b73e8"}
                    color={"#ffffff"}
                    _hover={{ background: "#1d5094", color: "#ffffff" }}
                    variant='solid' borderRadius={"20px"} mb={"18px"}
                    onClick={() => navigate("/students/add")}
                >
                    {t('addStudents')}
                </Button>
            )}
        </Flex>

        <Box bg="white" p={4} borderRadius="xl" boxShadow="0 1px 3px rgba(0,0,0,0.08)" mt={4} mb={6}>
            <Flex flexWrap="wrap" gap={4} alignItems="flex-end">
                <FormControl flex={{ base: "1 1 100%", md: "1 1 240px" }} maxW={{ base: "100%", md: "280px" }}>
                    <InputGroup>
                        <InputLeftElement pointerEvents="none" color="gray.400" h="100%">
                            <FiSearch size={18} />
                        </InputLeftElement>
                        <Input
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            bg="gray.50"
                            border="1px solid"
                            borderColor="gray.200"
                        />
                    </InputGroup>
                </FormControl>
                <FormControl flex={{ base: "1 1 100%", sm: "1 1 160px" }} maxW={{ base: "100%", sm: "200px" }}>
                    <SearchableSelect
                        options={provinces.map((p) => ({ label: p, value: p }))}
                        value={selectedProvince}
                        onChange={(e: any) => {
                            setSelectedProvince(e.target.value || "");
                            setSelectedDistrict("");
                        }}
                        label={t('selectProvince')}
                    />
                </FormControl>
                <FormControl flex={{ base: "1 1 100%", sm: "1 1 160px" }} maxW={{ base: "100%", sm: "200px" }}>
                    <SearchableSelect
                        options={districts.map((d) => ({ label: d, value: d }))}
                        value={selectedDistrict}
                        onChange={(e: any) => setSelectedDistrict(e.target.value || "")}
                        isDisabled={!selectedProvince && districts.length === 0}
                        label={t('selectDistrict')}
                    />
                </FormControl>
                <FormControl flex={{ base: "1 1 100%", sm: "1 1 160px" }} maxW={{ base: "100%", sm: "200px" }}>
                    <SearchableSelect
                        options={teachers.map((t) => ({ label: t, value: t }))}
                        value={selectedTeacher}
                        onChange={(e: any) => setSelectedTeacher(e.target.value || "")}
                        label={t('selectTeacher')}
                    />
                </FormControl>
            </Flex>
        </Box>

        <Box mt={"20px"} className="students-table" overflowX="auto" pb={4}>
            <Box minW="800px">
                <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                        title=""
                        columns={columns}
                        data={filteredData}
                        isLoading={loading} // Now using custom OverlayLoading component below
                        options={{
                            search: false,
                            sorting: true,
                            actionsColumnIndex: -1,
                            pageSize: 20,
                            paginationPosition: 'both'
                        }}
                        actions={[
                            isAdmin() && {
                                icon: 'delete',
                                tooltip: 'Delete Student',
                                onClick: (event: any, rowData: any) => {
                                    setDeleteIndex(event.studentId);
                                    onOpen();
                                }
                            },
                            isAdmin() && {
                                icon: 'transfer',
                                tooltip: 'Transfer Teacher / Therapist',
                                onClick: (event: any, rowData: any) => {
                                    setDeleteIndex(event.studentId);
                                    setRelationShip(event.relationships ?? []);
                                    setSelectedStudent(event);
                                    setSelectedRole(Roles.TEACHER);
                                    setRelationshipId("");
                                    onOpenTransfer();
                                }
                            }
                        ].filter(Boolean) as any}
                        components={{
                            Action: props => (
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <IconButton
                                        background={'#eeeeee'}
                                        p={"10px"}
                                        borderRadius={"10px"}
                                        aria-label='manage students'
                                        mr={"12px"}
                                        onClick={() => props.action.onClick(props.data)}
                                        icon={onGetIcon(props.action.icon)}
                                    />
                                </div>
                            ),
                            OverlayLoading: (props) => (
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    zIndex={100}
                                    bg="whiteAlpha.700"
                                    display={loading ? "flex" : "none"}
                                    alignItems="flex-start"
                                    justifyContent="center"
                                    pt="80px"
                                >
                                    <ModernLoader h="150px" message="Fetching students..." />
                                </Box>
                            )
                        }}
                    //  onRowClick={(event, rowData) => handleRowClick(event, rowData)}
                    />
                </ThemeProvider>
                <CoustomAlertDialog
                    onClose={handleClose}
                    onOpen={onOpen}
                    isOpen={isOpen}
                    onMainAction={onDeleteStudents}
                    loading={loading}
                />

                <Modal isOpen={isOpenTransfer} onClose={() => { onCloseTransfer(); resetTransferState(); }}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>{t('transfer.heading')}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <FormControl mb={4}>
                                <FormLabel>{t('transfer.role')}</FormLabel>
                                <SearchableSelect
                                    options={[Roles.TEACHER, Roles.THERAPIST].map(a => ({ label: a, value: a }))}
                                    value={selectedRole}
                                    onChange={(e: any) => {
                                        setSelectedRole(e.target.value as Roles);
                                        setRelationshipId("");
                                    }}
                                    label={t('transfer.role')}
                                    usePortal={false}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel>{t('transfer.user')}</FormLabel>
                                {(() => {
                                    const currentAssignment = selectedStudent?.relationships?.find(
                                        (r: any) => r.relation === selectedRole
                                    );
                                    const currentUserId = currentAssignment?.relatedUser?.id;
                                    const currentUserName = currentAssignment?.relatedUser?.displayName;
                                    const filteredUsers = users
                                        .filter((r) => r.roles?.includes(selectedRole) && r.id !== currentUserId)
                                        .map(a => ({ label: a.displayName, value: a.id }));
                                    return (
                                        <>
                                            {currentUserName && (
                                                <Text fontSize="xs" color="gray.500" mb={2}>
                                                    {t('transfer.currentlyAssigned')}: <strong>{currentUserName}</strong>
                                                </Text>
                                            )}
                                            <SearchableSelect
                                                options={filteredUsers}
                                                value={relationshipId}
                                                onChange={(e: any) => setRelationshipId(e.target.value)}
                                                label={filteredUsers.length === 0 ? t('transfer.noOptions') : t('transfer.user')}
                                                usePortal={false}
                                            />
                                        </>
                                    );
                                })()}
                            </FormControl>
                        </ModalBody>

                        <ModalFooter>
                            <Button variant='ghost' mr={3} onClick={() => { onCloseTransfer(); resetTransferState(); }}>
                                {t('transfer.close')}
                            </Button>
                            <Button colorScheme='blue' onClick={onTransferStudent} isLoading={loading}>
                                {t('transfer.transferStudent')}
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </Box>
        </Box>
    </Box>
}
